import React, { useState, useContext } from 'react'
import axios from 'axios'
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  Grid,
  Button,
  FormControl,
  FormGroup,
  FormControlLabel
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Dropzone from '../atoms/Dropzone'
import ValidationInput from '../atoms/ValidationInput'
import RightSideSubmitButton from '../molecules/RightSideSubmitButton'
import { formUploadHelper } from '../../helpers'
import WebViewModal from './WebViewModal'
import ConfigContext from '../../ConfigContext'

const validUrl = require('valid-url')

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  bannerImage: {
    margin: '0 auto',
    width: 240,
    objectFit: 'contain'
  },
  inputSort: {
    width: '50px'
  },
  previewImage: {
    width: '400px',
    objectFit: 'contain'
  }
}))

const ImagePicker: React.FC<{
  uploadHandler: () => void
}> = ({ uploadHandler }) => {
  const classes = useStyles({})
  const [fileObject, setFileObject] = useState<File | null>(null)
  const [preview, setPreview] = useState<string>('')
  const [previewURL, setPreviewURL] = useState<string>('')
  const [modalState, setModalState] = useState(false)
  const [previewIMG, setPreviewIMG] = useState({ webViewUrl: '', uploadImagePath: '' })
  const [banner, setBanner] = useState<{
    fileName: string
    href: string
    close_flg: boolean
    member_flg: boolean
    member_site_flg: boolean
  }>({
    fileName: '',
    href: '',
    close_flg: false,
    member_flg: false,
    member_site_flg: false
  })
  const config = useContext(ConfigContext)

  const handleDrop = async (file: File) => {
    setFileObject(file)
    setPreview(URL.createObjectURL(file))
    setBanner({
      ...banner,
      fileName: file.name
    })
  }

  const handleReset = async () => {
    setFileObject(null)
    setPreview('')
    setBanner({
      fileName: '',
      href: '',
      close_flg: false,
      member_flg: false,
      member_site_flg: false
    })
  }

  const handleSubmit = async () => {
    try {
      if (!banner.href && banner.member_site_flg) {
        alert('会員のシームレスログインを許可する場合は画像のリンク先URLを入力してください。')
        return
      }
      const imagePath = await formUploadHelper(banner.fileName, fileObject, '/upload/banners', true)
      const result = await axios.post('banners', {
        image_path: imagePath,
        href: banner.href,
        close_flg: banner.close_flg,
        member_flg: banner.member_flg,
        member_site_flg: banner.member_site_flg
      })
      // console.log(result)
      handleReset()
      uploadHandler()
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePreviewImg = async () => {
    try {
      const imagePath = await formUploadHelper(banner.fileName, fileObject, '/upload/banners', true)
      setPreviewIMG({
        webViewUrl: `${axios.defaults.baseURL}/previews/top-banner?img=${encodeURIComponent(
          imagePath
        )}`,
        uploadImagePath: imagePath
      })
      setModalState(true)
    } catch (error) {
      alert(error.message)
    }
  }

  const closePreviewImg = async () => {
    try {
      await axios.delete('/upload', {
        data: { path: previewIMG.uploadImagePath }
      })
      setModalState(false)
    } catch (error) {
      alert(error.message)
    }
  }

  const LinkCheck = (urlString: string) => {
    if (validUrl.isWebUri(urlString)) {
      window.open(urlString)
      return
    } else {
      alert('不正なリンクURLです。変更してください。')
      window.open('/page-not-found')
      return
    }
  }

  return (
    <React.Fragment>
      <Box>
        <Typography variant="body1" paragraph>
          【推奨サイズ】横：1170px、縦：804px
        </Typography>
        <Box>
          <Dropzone
            dropHandler={files => handleDrop(files[0])}
            accept="image/jpeg, image/png, image/gif"
          />
        </Box>
        <Box>
          {fileObject instanceof File && (
            <React.Fragment>
              <Box display="flex">
                <Box p={4} mr={2}>
                  <img className={classes.previewImage} src={preview} alt="preview img" />
                </Box>
                <Box>
                  <Grid container alignItems="center">
                    {config.enableBannerPreview === '1' && (
                      <Grid item xs={12} sm={12} md={1}></Grid>
                    )}
                    {config.enableBannerPreview === '1' && (
                      <Grid item xs={12} sm={12} md={11}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handlePreviewImg()}
                          style={{ marginTop: 25 }}
                        >
                          プレビュー
                        </Button>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={12} md={1}></Grid>
                    <Grid item xs={12} sm={12} md={11}>
                      <Typography variant="body1" style={{ marginTop: '1rem' }}>
                        画像のリンク先を設定してください。
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={1}>
                      <Typography variant="subtitle2">リンクURL</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={7}>
                      <Box marginRight={2}>
                        <TextField
                          value={banner.href}
                          onChange={(event: any) => {
                            setBanner({
                              ...banner,
                              href: event.target.value
                            })
                            setPreviewURL(event.target.value)
                          }}
                          margin="normal"
                          variant="outlined"
                          placeholder="リンクURLを入力"
                          fullWidth
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          LinkCheck(previewURL)
                        }}
                        disabled={!previewURL}
                      >
                        リンク確認
                      </Button>
                    </Grid>

                    {config.enableBannerMemberFlg === '1' && (
                      <Grid item xs={12} sm={12} md={1}></Grid>
                    )}
                    {config.enableBannerMemberFlg === '1' && (
                      <Grid item xs={12} sm={12} md={11}>
                        <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                          <FormGroup aria-label="position" row>
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  checked={banner.member_flg}
                                  onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                    checked: boolean
                                  ) =>
                                    setBanner({
                                      ...banner,
                                      member_flg: checked
                                    })
                                  }
                                />
                              }
                              label="会員のみバナーを表示"
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    )}

                    {config.enableBannerMemberSiteFlg === '1' && (
                      <Grid item xs={12} sm={12} md={1}></Grid>
                    )}
                    {config.enableBannerMemberSiteFlg === '1' && (
                      <Grid item xs={12} sm={12} md={11}>
                        <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                          <FormGroup aria-label="position" row>
                            <FormControlLabel
                              value="top"
                              control={
                                <Checkbox
                                  checked={banner.member_site_flg}
                                  onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                    checked: boolean
                                  ) =>
                                    setBanner({
                                      ...banner,
                                      member_site_flg: checked
                                    })
                                  }
                                />
                              }
                              label={
                                <span>
                                  会員のシームレスログインを許可する
                                  <br />
                                  ※指定するURLが会員認証を必要とするサイトの場合、会員はシームレスにログインすることができます。
                                </span>
                              }
                              labelPlacement="end"
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={1}></Grid>
                    <Grid item xs={12} sm={12} md={11}>
                      <Typography variant="body1" style={{ marginTop: 25 }}>
                        画像は登録と同時に公開されます。
                        <br />
                        登録後、「非公開」にする場合は「非表示にする」を選択してください。
                      </Typography>
                      <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                        <FormGroup aria-label="position" row>
                          <FormControlLabel
                            value="top"
                            control={
                              <Checkbox
                                checked={banner.close_flg}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>,
                                  checked: boolean
                                ) =>
                                  setBanner({
                                    ...banner,
                                    close_flg: checked
                                  })
                                }
                              />
                            }
                            label="非表示にする"
                            labelPlacement="end"
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </React.Fragment>
          )}
        </Box>
        <Box my={3}>
          <RightSideSubmitButton
            submittable={banner.fileName.length > 0}
            resettable
            submitHandler={() => {
              handleSubmit()
            }}
            resetHandler={() => handleReset()}
          />
        </Box>
      </Box>
      <WebViewModal
        isOpen={modalState}
        handleClose={() => closePreviewImg()}
        url={previewIMG.webViewUrl}
        appliTopPage={true}
      />
    </React.Fragment>
  )
}

export default ImagePicker
